<template>
    <v-card>
        <v-toolbar
            dark
            color="indigo"
        >
            <v-menu
                v-model="menuVisible"
                :close-on-content-click="true"
                max-width="290"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="dateFormatted"
                        label="Seçili gün"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="mt-8"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="selectedDate"
                    color="indigo accent-6"
                    full-width
                    :first-day-of-week="1"
                    :allowed-dates="allowedDates"
                ></v-date-picker>
            </v-menu>

            <v-spacer></v-spacer>

            <v-btn
                small
                color="white"
                text
                @click="print"
            >
                <v-icon>
                    mdi-printer
                </v-icon>
                Yazdır
            </v-btn>
        </v-toolbar>

        <div id="printThis">
            <div style="padding: 2rem">
                <v-row>
                    <div class="text-left">
                        <div class="h1"><b>Günlük Özet</b></div>
                        <div class="h2"><b>Bugun toplam tahsilat:</b> ₺{{ toplamTahsilat }}</div>
                        <div class="h2"><b>Toplam kontrol sayısı:</b> {{ toplamSayi }}</div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="h1"><small><b>Yazdırma zamanı:</b><br>{{ bugun }}</small></div>
                </v-row>
            </div>
            <v-list three-line>
                <template
                    v-for="({ sirket_adi, tahsilat_tutari, sehir, dolum_ml, kontrol_zamani, not }, index) in kontroller">
                    <v-list-item
                        :key="sirket_adi + index"
                        class="text-left"
                    >
                        <v-list-item-avatar>
                            {{ index + 1 }}
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ sirket_adi }} - {{ sehir }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                ₺{{ tahsilat_tutari }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                {{ dolum_ml }}ml
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                {{ kontrol_zamani }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                {{ not }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </div>
    </v-card>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'mak-gunluk-kontroller',
        data() {
            return {
                selectedDate: moment().format('YYYY-MM-DD'),
                kontroller: [],
                menuVisible: false,
                loading: false,
            };
        },
        computed: {
            bugun() {
                return moment().format('dddd, MMMM Do YYYY');
            },
            toplamSayi() {
                return this.kontroller.length;
            },
            toplamTahsilat() {
                return this.kontroller.reduce((r, { tahsilat_tutari }) => (r + (parseFloat(tahsilat_tutari) || 0)), 0);
            },
            dateFormatted () {
                return this.selectedDate ? moment(this.selectedDate).format('dddd, MMMM Do YYYY') : ''
            },
        },
        methods: {
            async print() {
                await this.$htmlToPaper('printThis');
            },
            allowedDates(date) {
                return moment(date).diff(moment(), 'days') <= 0;
            },
            fetch() {
                if (!this.selectedDate) {
                    return;
                }

                this.loading = true;
                this.$requests.MusteriKontrol
                    .getMusteriKontrolGun(this.selectedDate)
                    .then((data) => {
                        this.kontroller = data || [];
                    })
                    .catch((error) => {
                        console.error(`error on loading getMusteriKontrolGun`, error);
                    })
                    .then(() => this.loading = false);
            },
        },
        mounted() {
            this.fetch();
        },
        watch: {
            selectedDate() {
                this.fetch();
            },
        },
    };
</script>
